import React, { useEffect, useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { fetchSingleUser } from "../../utils/UserComponents";
import { useLocation } from 'react-router-dom';
import UserProfile from './UserProfile';
import UserProfileAdmin from './UserProfileAdmin';
import ViewUserSideBar from './ViewUserSideBar';

const ViewUserProfile = () => {
    const location = useLocation();
    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);
    const role = location?.state?.role || localStorage.getItem('role');
    useEffect(() => {
        const id = location.pathname.split('/').pop();
        fetchSingleUser(id, setUser);
        setLoading(false);
    }, [location.pathname]);

    return (
        <>
            <Header />
            {loading ? <div className="container loading-dots"><span>.</span><span>.</span><span>.</span></div>
                :
                <div className="dashboard">
                    <ViewUserSideBar />
                    <div className="content">
                        {user && (
                            role === 'admin' ?
                                <UserProfileAdmin user={user} role={role} />
                                :
                                <UserProfile user={user} role={role} />
                        )
                        }
                    </div>
                </div>
            }
            <Footer />
        </>
    );
};

export default ViewUserProfile;
